import { useAuthContext } from '../context/AuthContext';
import { useState, useMemo, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import GerenciadorUsuarios from '../components/GerenciadorUsuarios';
import GerenciadorFormacoes from '../components/GerenciadorFormacoes';
import GerenciadorInstrucoes from '../components/GerenciadorInstrucoes';
import GerenciadorHorarios from '../components/GerenciarHorarios';
import AgendaAdminPage from '../components/AgendaAdminPage';
import GerenciadorEscala from '../components/GerenciadorEscalas';
import GerarEscala from '../components/GerarEscalas';
import Frequencia from '../components/Frequencia';
import api from '../services/api';

// Ícones SVG para a sidebar
const IconeUsuario = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>;
const IconeFormacao = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" /></svg>;
const IconeInstrucao = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>;
const IconeHorario = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
const IconeAgenda = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>;
const IconeEscala = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
const IconeFrequencia = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M3 3v18h18"/><path strokeLinecap="round" strokeLinejoin="round" d="M7 13v6M12 9v10M17 5v14"/></svg>
);
const tabs = {
  usuarios: { label: "Usuários", icon: <IconeUsuario /> },
  formacoes: { label: "Formações", icon: <IconeFormacao /> },
  horarios: { label: "Horários", icon: <IconeHorario /> },
  frequencia: { label: "Frequência", icon: <IconeFrequencia /> },
  agenda: { label: "Agenda", icon: <IconeAgenda /> },
  instrucoes: { label: "Instruções", icon: <IconeInstrucao /> },
  escala:{ label: "Gerenciar Escala", icon: <IconeEscala /> },
  GerarEscala:{ label: "Gerar Escala", icon: <IconeEscala /> },
};

// Regras de acesso por aba (micro-permissionamento)
// Cada entrada pode listar roles (case-insensitive) e/ou perms (strings esperadas em usuario.permissions)
const accessRules = {
  usuarios: { roles: ['admin','coordenador'], perms: ['coordenacao.usuarios'] },
  formacoes: { roles: ['admin','coordenador'], perms: ['coordenacao.formacoes'] },
  horarios: { roles: ['admin','coordenador'], perms: ['coordenacao.horarios'] },
  agenda: { roles: ['admin','coordenador'], perms: ['coordenacao.agenda'] },
  instrucoes: { roles: ['admin','coordenador'], perms: ['coordenacao.instrucoes'] },
  escala: { roles: ['admin','coordenador'], perms: ['coordenacao.escala'] },
  GerarEscala: { roles: ['admin','coordenador'], perms: ['coordenacao.gerar_escala'] },
  frequencia: { roles: ['admin','coordenador'], perms: ['coordenacao.frequencia'] },
};

export default function CoordenacaoDashboard() {
  // Recarrega a página na primeira vez que acessar a coordenacao (por sessão)
  useEffect(() => {
    if (!window.sessionStorage.getItem('coordenacaoReloaded')) {
      window.sessionStorage.setItem('coordenacaoReloaded', 'true');
      window.location.reload();
    }
  }, []);
  const { user, token, loading, setUser } = useAuthContext();
  const [activeTab, setActiveTab] = useState("usuarios");
  // Força reset de estados das abas ao trocar
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [error, setError] = useState(null);
  const [coordenador, setCoordenador] = useState(null);
  // Removido apiLoading: cada aba deve controlar seu próprio loading
  const navigate = useNavigate();
  const location = useLocation();

  // Extrai grupo_id da URL
  const searchParams = new URLSearchParams(location.search);
  const grupoIdFromUrl = searchParams.get('grupo_id');

  useEffect(() => {
    let localAbortController = new AbortController();
    setError(null);

    async function fetchUser() {
      if (!token) return;
      // Se for admin E grupoIdFromUrl válido, busca coordenador do grupo
      if (user?.roles?.map(r => r.toLowerCase()).includes('admin') && grupoIdFromUrl && grupoIdFromUrl !== 'undefined' && grupoIdFromUrl !== '') {
        try {
          const res = await api.get(`/auth/me?grupo_id=${grupoIdFromUrl}`, {
            headers: { Authorization: `Bearer ${token}` },
            signal: localAbortController.signal,
          });
          setCoordenador(res.data);
          setError(null);
        } catch (err) {
          if (err.name === 'CanceledError' || err.name === 'AbortError') {
            // Request aborted, do nothing
          } else if (err.response && err.response.status === 404) {
            setError('Coordenador não encontrado para o grupo informado.');
            setCoordenador(null);
          } else if (err.message === 'Network Error') {
            setError('Erro de rede ao buscar coordenador. Verifique sua conexão.');
            setCoordenador(null);
          } else {
            setError('Erro ao buscar coordenador.');
            setCoordenador(null);
          }
        }
      } else {
        if (user?.roles?.map(r => r.toLowerCase()).includes('coordenador')) {
          if (!user._fetched) {
            try {
              const res = await api.get('/auth/me', {
                headers: { Authorization: `Bearer ${token}` },
                signal: localAbortController.signal,
              });
              setUser({ ...res.data, _fetched: true });
              setError(null);
            } catch (err) {
              if (err.name === 'CanceledError' || err.name === 'AbortError') {
                // Request aborted, do nothing
              } else if (err.message === 'Network Error') {
                setError('Erro de rede ao buscar usuário. Verifique sua conexão.');
                setUser(null);
              } else {
                setError('Erro ao buscar usuário.');
                setUser(null);
              }
            }
          }
        }
      }
    }
    // Executa sempre que token ou grupoId mudam
    if (token && user) {
      if (user.roles?.map(r => r.toLowerCase()).includes('admin') && grupoIdFromUrl && grupoIdFromUrl !== 'undefined' && grupoIdFromUrl !== '') {
        fetchUser();
      } else if (user.roles?.map(r => r.toLowerCase()).includes('coordenador')) {
        fetchUser();
      }
    }
    // Cleanup: abort request if component unmounts or effect re-runs
    return () => {
      localAbortController.abort();
    };
  }, [token, grupoIdFromUrl, user, setUser]);

  // Prioriza coordenador se buscado, senão usa usuário logado
  const usuarioPainel = coordenador || user;

  const grupoComIDs = useMemo(() => {
    if (!usuarioPainel) return null;
    return {
      diocese: usuarioPainel.diocese,
      paroquia: usuarioPainel.paroquia,
      paroquia_id: usuarioPainel.paroquia_id,
      comunidade: usuarioPainel.comunidade,
      comunidade_id: usuarioPainel.comunidade_id,
      tipo: usuarioPainel.tipo,
      grupo_id: usuarioPainel.grupo_id,
    };
  }, [usuarioPainel]);

  // Se o usuarioPainel mudou, garante que a aba ativa seja permitida; se não, escolhe a primeira permitida
  // Nota: não forçamos mudança automática de aba aqui — queremos permitir acesso
  // direto às abas mesmo quando elas não aparecem no menu.

  // Permissão: só coordenador OU admin pode acessar (case-insensitive)
  const roles = (usuarioPainel?.roles || []).map(r => r.toLowerCase());

  // helper: verifica regras de acesso para uma aba
  function hasAccess(tabKey) {
    const rule = accessRules[tabKey];
    if (!rule) return true; // se não há regra, permite
    // primeiro: se a regra define permissões explícitas, exija-as
    const perms = (usuarioPainel?.permissions || []).map(p => (p || '').toLowerCase());
    if (rule.perms && Array.isArray(rule.perms) && rule.perms.length > 0) {
      return rule.perms.some(p => perms.includes(p));
    }
    // caso não haja perms definidas, fallback para roles
    if (rule.roles && Array.isArray(rule.roles) && rule.roles.length > 0) {
      return rule.roles.some(r => roles.includes(r));
    }
    return true;
  }
  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-slate-50">
        <div className="bg-white p-8 rounded-xl shadow text-center max-w-md">
          <h2 className="text-2xl font-bold text-red-600 mb-2">Erro</h2>
          <p className="text-gray-700 mb-6">{error}</p>
          <button
            onClick={() => navigate('/')}
            className="px-6 py-3 bg-indigo-600 text-white rounded-lg font-semibold shadow hover:bg-indigo-700 transition-colors"
          >
            ← Voltar para Home
          </button>
        </div>
      </div>
    );
  }
  // Não bloqueamos o acesso globalmente aqui — a visibilidade do menu é controlada
  // por `hasAccess` por item. O conteúdo das abas ainda pode ser renderizado
  // se `activeTab` apontar para elas (por exemplo via estado/URL interno).
  if (loading || (token && !usuarioPainel)) {
    // Só mostra loading global durante autenticação inicial
    return (
      <div className="flex items-center justify-center h-screen bg-slate-50">
        <p className="text-xl text-slate-500">A carregar dados do utilizador...</p>
      </div>
    );
  }
  if (!grupoComIDs) {
    return (
      <div className="flex items-center justify-center h-screen bg-slate-50">
        <p className="text-xl text-slate-500">Usuário não encontrado.</p>
        <p className="text-xl text-slate-500">Recarregue a página ou tente novamente mais tarde.</p>
      </div>
    );
  }

  return (
    <div className="relative md:flex h-screen bg-slate-50 font-sans">
      {/* Overlay para ecrãs pequenos */}
      {isSidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-20 md:hidden" 
          onClick={() => setIsSidebarOpen(false)}
        ></div>
      )}

      {/* Sidebar */}
      <aside className={`fixed inset-y-0 left-0 w-64 bg-slate-900 text-slate-200 flex flex-col transform ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} md:relative md:translate-x-0 transition-transform duration-300 ease-in-out z-30`}>
        <div className="h-20 flex items-center justify-center text-2xl font-bold tracking-wider border-b border-slate-700">
          PAINEL
        </div>
        <nav className="flex-1 px-4 py-6 space-y-2">
          {Object.entries(tabs).map(([key, { label, icon }]) => {
            // ocultar completamente itens sem permissão
            if (!hasAccess(key)) return null;
            return (
              <button
                key={key}
                onClick={() => {
                  setActiveTab(key);
                  setIsSidebarOpen(false);
                }}
                className={`w-full flex items-center gap-4 px-4 py-3 rounded-lg text-sm font-semibold transition-all duration-200 ${
                  activeTab === key
                    ? 'bg-indigo-600 text-white shadow-lg'
                    : 'text-slate-400 hover:bg-slate-700 hover:text-white'
                }`}>
                {icon}
                <span>{label}</span>
              </button>
            );
          })}
        </nav>
  <div className="p-4 text-center border-t border-slate-700">
            <p className="text-xs text-slate-500">© {new Date().getFullYear()} - Todos os direitos reservados</p>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-y-auto">
        <div className="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8">
          {/* Header */}
          <header className="flex items-center justify-between mb-10">
            <div>
              <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-800 tracking-tight">Painel de Coordenação</h1>
              <p className="text-base sm:text-lg text-slate-500 mt-2">
                {grupoComIDs?.tipo || usuarioPainel?.tipo} | {grupoComIDs?.comunidade || usuarioPainel?.comunidade}, {grupoComIDs?.paroquia || usuarioPainel?.paroquia} - {grupoComIDs?.diocese || usuarioPainel?.diocese}
              </p>
            </div>
            {/* Botão Hamburguer para Mobile */}
            <button 
              className="md:hidden p-2 rounded-md text-slate-600 hover:bg-slate-200"
              onClick={() => setIsSidebarOpen(true)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg>
            </button>
            {/* Botão Voltar para Home */}
            <button
              onClick={() => navigate(-1)}
              className="hidden md:inline-block ml-4 px-6 py-2 bg-indigo-600 text-white rounded-lg font-semibold shadow hover:bg-indigo-700 transition-colors"
            >
              ← Voltar para Home
            </button>
          </header>
          
          {/* Botão Voltar para Home para mobile */}
          <div className="md:hidden mb-4">
            <button
              onClick={() => navigate(-1)}
              className="w-full px-6 py-3 bg-indigo-600 text-white font-semibold shadow hover:bg-indigo-700 transition-colors"
            >
              ← Voltar para Home
            </button>
          </div>

          {/* Content Card */}
          <div className="bg-white shadow-xl shadow-slate-200/50 rounded-2xl p-4 sm:p-6 lg:p-8 min-h-[500px]">
            {activeTab === "usuarios" && hasAccess('usuarios') && <GerenciadorUsuarios key={"usuarios-"+activeTab+"-"+(grupoComIDs?.grupo_id||'no-grupo')} grupo={grupoComIDs} usuarioPainel={usuarioPainel} token={token} />}
            {activeTab === "formacoes" && hasAccess('formacoes') && <GerenciadorFormacoes key={"formacoes-"+activeTab+"-"+(grupoComIDs?.grupo_id||'no-grupo')} grupo={grupoComIDs} usuarioPainel={usuarioPainel} token={token} />}
            {activeTab === "horarios" && hasAccess('horarios') && <GerenciadorHorarios key={"horarios-"+activeTab+"-"+(grupoComIDs?.grupo_id||'no-grupo')} grupo={grupoComIDs} usuarioPainel={usuarioPainel} token={token} />}
            {activeTab === "agenda" && hasAccess('agenda') && <AgendaAdminPage key={"agenda-"+activeTab+"-"+(grupoComIDs?.grupo_id||'no-grupo')} grupo={grupoComIDs} usuarioPainel={usuarioPainel} token={token} />}
            {activeTab === "instrucoes" && hasAccess('instrucoes') && <GerenciadorInstrucoes key={"instrucoes-"+activeTab+"-"+(grupoComIDs?.grupo_id||'no-grupo')} grupo={grupoComIDs} usuarioPainel={usuarioPainel} token={token} />}
            {activeTab === "escala" && hasAccess('escala') && <GerenciadorEscala key={"escala-"+activeTab+"-"+(grupoComIDs?.grupo_id||'no-grupo')} grupo={grupoComIDs} usuarioPainel={usuarioPainel} token={token} />}
            {activeTab === "GerarEscala" && hasAccess('GerarEscala') && <GerarEscala key={"GerarEscala-"+activeTab+"-"+(grupoComIDs?.grupo_id||'no-grupo')} grupo={grupoComIDs} usuarioPainel={usuarioPainel} token={token} />}
            {activeTab === "frequencia" && hasAccess('frequencia') && <Frequencia key={"frequencia-"+activeTab+"-"+(grupoComIDs?.grupo_id||'no-grupo')} grupo={grupoComIDs} usuarioPainel={usuarioPainel} token={token} />}
          </div>
        </div>
      </main>
    </div>
  );
}